import * as Yup from "yup";

export const logInSchema = Yup.object({
    username: Yup.string().required(" Enter User Name"),
    password: Yup.string().required(" Enter Password"),
});
